import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PageLayout from '../components/PageLayout';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Button, Box, Alert, CircularProgress } from '@mui/material';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { Location } from '../types/Location';
import { LocationDetailsView } from '../components/LocationDetailsView';

export const LocationDetailsPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [location, setLocation] = useState<Location | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!id) return;

        const unsubscribe = onSnapshot(doc(db, 'locations', id), (docSnap) => {
            if (docSnap.exists()) {
                setLocation({ id: docSnap.id, ...docSnap.data() } as Location);
            } else {
                console.log("No such document!");
                setLocation(null);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, [id]);

    if (loading) {
        return (
            <PageLayout>
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <CircularProgress />
                </Box>
            </PageLayout>
        );
    }

    if (!location) {
        return (
            <PageLayout>
                <Alert severity="error">Lieu introuvable.</Alert>
                <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/locations')} sx={{ mt: 2 }}>
                    Retour à la liste
                </Button>
            </PageLayout>
        );
    }

    return (
        <PageLayout>
            <Button
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate('/locations')}
                sx={{ mb: 2, color: 'text.secondary' }}
            >
                Retour aux salles
            </Button>

            <LocationDetailsView location={location} />
        </PageLayout>
    );
};
